var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cross_svg__a",
    width: "133.6%",
    height: "141.9%",
    x: "-16.2%",
    y: "-18.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.439215686 0 0 0 0 0.564705882 0 0 0 0 0.690196078 0 0 0 0.15 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "cross_svg__b",
    d: "M8 377.31a8 8 0 01-8-8V8a8 8 0 018-8h461a8 8 0 018 8v17.011l9.799 7.818-.058.045.158.126L477 40.898v328.411a8 8 0 01-8 8H8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E1E7EE",
    d: "M-1063-742H377V549h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-638 -164)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 895,
    height: 518,
    fill: "#FFF",
    rx: 6
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000",
    fontSize: 22,
    fontWeight: "bold",
    transform: "translate(563 160)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.704,
    y: 22
  }, "\u20B9 6,000"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-442 -23)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#cross_svg__a)",
    xlinkHref: "#cross_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#cross_svg__b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.105.113a.558.558 0 01.732.839L6.788 6l5.049 5.048a.558.558 0 01-.732.839l-.057-.05L6 6.788.952 11.837l-.057.05a.558.558 0 01-.732-.839L5.212 6 .163.952A.558.558 0 01.895.113l.057.05L6 5.212 11.048.163z",
    fill: "#141823",
    fillRule: "nonzero"
  }))));
}
export default SvgCross;